module.exports = __webpack_public_path__ + "media/camioneta.52d71709.mp4";